<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
              <el-aside width="330px">
                 <sidebar></sidebar>
              </el-aside>
              <el-main>
                 <headSide @release="gorelease()"></headSide>
                 <!--参与课程-->
                 <div class="mt-30">
                    <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
                    <div class="content">
                       <div class="cont_list" v-for="(item,index) in list" :key="index" @click="onView(item)">
                           <div class="cont_list_img">
                               <img :src="item.cover">
							                 <img class="model" src="@/assets/images/play.png" />
                           </div>                          
                          <div class="cont_cox">
                            <p class="list_title">{{item.title}}</p>
                            <p class="list_texts">{{item.des}}</p>
                            <div class="list_foor">
                               <p class="list_text">
                                 <span>观看时间:</span>
                                 <span>{{item.opendate.substring(0,10)}}</span>
                               </p>
                               <p class="list_num">
                                  <span class="f14">￥{{item.price}}</span>
                               </p>
                            </div>
                          </div>
                       </div>
                    </div>

                    <!--分页-->
                     <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
                       <div style="margin-top:10%;">
                           <notList :notCode="notCode"></notList>
                       </div>
                 </div>
                 <!--购买课程-->
                 <div class="mt-30">
                    <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
                    <div class="content">
                       <div class="cont_list" v-for="(row,index) in purList" :key="index"  @click="onView(row)">
                           <div class="cont_list_img">
                               <img :src="row.goodscover">
							                 <img class="model" src="@/assets/images/play.png" />
                           </div>                          
                          <div class="cont_cox">
                            <p class="list_title">{{row.goodsName}}</p>
                            <p class="list_texts" v-html="row.content"></p>
                            <div class="list_foor">
                               <p class="list_text">
                                 <span>观看时间:</span>
                                 <span v-if="row.transDate">{{row.transDate.substring(0,10)}}</span>
                               </p>
                               <p class="list_num">
                                  <span class="ft14">￥{{row.amount}}</span>
                               </p>
                            </div>
                          </div>
                       </div>
                    </div>

                    <!--分页-->
                    <Pagination v-show="totals>0"   :total="totals"  :page.sync="dataQuery.curPage" :limit.sync="dataQuery.limit" @pageChange="pageChanges" ></Pagination>
                     <div style="margin-top:15%;">
                          <notList :notCode="notCodes"></notList>
                      </div>
                 </div>
              </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {expertCollege} from "@/api/expert"
import {myCollegeList} from "@/api/coment"
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
      sidebar,headSide,commBanner,titleHead,contTitle,Pagination,notList
  },
  data(){
      return{
        contTitle:'参与课程',
        contTitle1:'购买课程',
        headTitle:'我的课程',
        obj:{
            title:'我的课程',        
            contCount:'',
            isShow:true,
            roleType:2,
            personalType:9,
        },
        listQuery:{
          curPage:1,
          limit:4
        },
        dataQuery:{
          curPage:1,
          limit:4
        },
        list:[],
        purList:[],
        total:0,//总条数
        totals:0,
        notCode:false,
        notCodes:false
      }
  },
  created(){
     this.getList();
     this.getListPur();
     if(this.$store.state.user.userInfo.type ==2){
          this.obj.roleType = 2;
      }
  },
  methods:{
     onView(item){
       this.$router.push({
         path:'/environmental_college_detail',
         query:{
           id:item.goodsId
         }
       });
     },
     //获取列表(参与课程)
     getList(){
       expertCollege(this.listQuery).then(res=>{
           if(res.code ==0){
             res.data.list.forEach((item)=>{
               if(item.goodsotherinfo2 =='0'){
                 this.list.push(item)
               }
             });
           }
          if(this.list.length == 0){
            this.notCode = true;
          }else{
              this.notCode = false;
          }
       }).catch(err=>{})
     },
     //购买课程列表
     getListPur(){
       myCollegeList(this.listQuery).then((res)=>{
         if(res.code ==0){
             res.page.list.forEach((item)=>{
               if(item.goodsotherinfo2 =='0'){
                 this.purList.push(item)
               }
             });
             this.totals = this.purList.length;
            //  this.obj.contCount = this.purList.length;
         }
         if(this.purList.length ==0){
            this.notCodes = true;
          }else{
              this.notCodes = false;
          }
       }).catch((res)=>{})
     },
     //参与课程分页
    pageChange(item){
      this.listQuery['curPage'] = item.page;
      this.listQuery['limit'] = item.limit;
      this.getList();
    },
    //购买课程分页
    pageChanges(){
      this.dataQuery['curPage'] = item.page;
      this.dataQuery['limit'] = item.limit;
      this.getListPur();
    },
    gorelease(){
      this.$router.push('/demand')
    }
  },  
}
</script>
<style scoped>
.el-aside{
  height:100%;
}
.ft14{
  font-size: 14px;
}
.mr6{
  margin-right: -6px;
}
.mt20{
  margin-top: 20px;
}
.content{
  margin-top: 20px;
  /* border: 1px solid red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.content:after{
  content: '';
  width: 218px;
}
.cont_list{
  width: 31%;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 20px;
  border: 1px solid #EEEEEE;
}

.cont_list_img{
   width: 100%;
   height: 155px;
   position: relative;
   overflow: hidden;
}
.cont_list_img img{
   width: 100%;
   height: 100%;
   transition: all 0.5s; 
}
.cont_list_img img:nth-child(1):hover{
	transform: scale(1.2);
}
.model{
	position: absolute;
	width: 50px !important;
	height: 50px !important;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 999;
}
.cont_cox{
    /* width: 65%; */
    height: 100%;
    padding: 0px 15px;
    margin-bottom: 15px;
}
.list_foor{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.list_foor p{
  display: inline-block;
}
.list_title{ 
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list_texts{
  margin-top: 5px;
  font-size: 13px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.list_text span{  
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
}
.list_num{ 
  font-size: 20px;
  font-family: Arial;
  font-weight: 400;
  color: #FF7402;
  display: flex;
  justify-content: space-between;
}
.el-pagination{
   margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/view/expert/expert_curriculum.vue